const STORAGE_KEY = "grozykart-admin-session-v1";

export const defaultSessionUser = {
  id: "",
  name: "",
  email: "",
  role: "",
  phone: "",
  location: "",
  timezone: "Asia/Kolkata",
  status: "",
};

export function loadPersistedSession() {
  if (typeof window === "undefined" || !window.localStorage) {
    return null;
  }

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") {
      return null;
    }

    return parsed;
  } catch (error) {
    return null;
  }
}

export function getPersistedAccessToken() {
  return String(loadPersistedSession()?.accessToken || "").trim();
}

export function persistSession(snapshot) {
  if (typeof window === "undefined" || !window.localStorage) {
    return;
  }

  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(snapshot));
  } catch (error) {
    return;
  }
}

export function clearPersistedSession() {
  if (typeof window === "undefined" || !window.localStorage) {
    return;
  }

  window.localStorage.removeItem(STORAGE_KEY);
}
